import { useMutation, useQuery } from '@tanstack/react-query';
import {
  DowngradeCheckResponse,
  PaymentHistoryResponse,
  PlanResponse,
  StartTrialResponse,
  SubscriptionPurchaseResponse,
  SubscriptionStatusResponse
} from '../types/plan.types';
import { planServiceApi } from '../services/plan.service';
import { AxiosError } from 'axios';
interface ApiErrorResponse {
  data?: {
    message?: string;
    error?: string;
  };
  message?: string;
  error?: string;
  statusCode?: number;
}
export const usePlans = () => {
  return useQuery<PlanResponse, Error>({
    queryKey: ['plans'],
    queryFn: () => planServiceApi.getPlans(),
  });
};

export const useSubscriptionStatus = () => {
  return useMutation<
    SubscriptionStatusResponse,
    AxiosError<ApiErrorResponse>,
    { orderId: string}
  >({
    mutationFn: ({ orderId }) =>
      planServiceApi.subscriptionStatus(orderId),
  });
};

export const useSubscriptionPurchase = () => {
  return useMutation<
    SubscriptionPurchaseResponse,
    AxiosError<ApiErrorResponse>,
    { subscriptionId: string; billingCycle: string; chatBotId: string; autoPay?: boolean }
  >({
    mutationFn: ({ subscriptionId, billingCycle, chatBotId, autoPay }) =>
      planServiceApi.subscriptionPurchase(subscriptionId, billingCycle, chatBotId, autoPay),
  });
};

export const useStartTrialSubscription = () => {
  return useMutation<
    StartTrialResponse,
    AxiosError<ApiErrorResponse>,
    { subscriptionId: string; chatBotId: string }
  >({
    mutationFn: ({ subscriptionId, chatBotId }) =>
      planServiceApi.startTrial(subscriptionId, chatBotId),
  });
};

export const usePaymentHistory = (chatBotId:string) => {
  return useQuery<PaymentHistoryResponse, Error>({
    queryKey: ['payment-history',chatBotId],
    queryFn: () => planServiceApi.paymentHistory(chatBotId),
  });
};

export const useDowngradeCheck = () => {
  return useMutation<
    DowngradeCheckResponse,
    AxiosError<ApiErrorResponse>,
    { subscriptionId: string,chatBotId:string }
  >({
    mutationFn: ({ subscriptionId,chatBotId }) =>
      planServiceApi.downgradeCheck(subscriptionId,chatBotId),
  });
};
